module.exports = __webpack_public_path__ + "img/3.cf4d6eb0.png";